module.exports = __webpack_public_path__ + "static/media/logo.0726e4af.svg";